import { useEffect, useCallback } from "react";
import { useAppContext } from "./useAppContext";
import { useGoogleAnalytics } from "./useGoogleAnalytics";
import { useIsPreviewMode } from "./useIsPreviewMode";
import { useMessage } from "./useMessage";

// Remark: This is a global state,
// so if multiple hooks are used, it can be set multiple times
// I think this is not a problem for this usecase because we only want to log the event once
let shouldLogAiPhotoBookEvent = false;

/**
 * Isolated the AI Photo Book logging logic
 * Remark: At useEffect and useMessage will happen for each hook instance running
 */
export function useLogAiAssistedPreviewExit() {
	const googleAnalytics = useGoogleAnalytics();
	const [isPreviewMode] = useIsPreviewMode();
	const { editor, platform } = useAppContext();

	// When the first load product is a AI assisted product (and we are in previewMode), we mark for logging event.
	useMessage((message) => {
		// We assume the defintion is loaded after the header is rendered (this hook is started)
		if (eXpress.core.isFirstDefinitionLoad(message)) {
			if (platform.queryString.getQueryStringToggle("previewmode")) {
				shouldLogAiPhotoBookEvent = editor.definition?.isAiAssistedProduct ?? false;
			}
		}
	});

	// When leaving preview mode, don't log anymore
	useEffect(() => {
		shouldLogAiPhotoBookEvent = false;
	}, [isPreviewMode]);

	return {
		/** Only logs once for AI assisted products */
		logGaEvent: useCallback(
			(event: eXpress.GaEventInfo) => {
				if (shouldLogAiPhotoBookEvent) {
					googleAnalytics.trackEventToGa(event);
				}
			},
			[googleAnalytics],
		),
	};
}
